/**
 * walkanywear-gallery.js
 * Transforms the Dawn stacked gallery into a single main image + thumbnail strip.
 * Works regardless of the section's gallery_layout setting.
 */
(function () {
  'use strict';

  var PER_PAGE = 4;

  function initGallery() {
    var mediaWrapper = document.querySelector('.product__media-wrapper');
    if (!mediaWrapper) return;

    // The element the strip will live INSIDE (so it stays glued to the image).
    var gallery = mediaWrapper.querySelector('media-gallery') || mediaWrapper;

    // Kill Dawn's sticky behaviour — sticky pins the image on scroll and lets the
    // strip (and the next section) overlap it. Static keeps the whole column flowing.
    gallery.classList.remove('product__column-sticky');
    gallery.style.position = 'static';
    mediaWrapper.style.position = 'static';

    var slides = Array.from(mediaWrapper.querySelectorAll('.product__media-item'));
    if (slides.length <= 1) return;

    // Force-load every slide image. They're loading="lazy" + display:none, so the
    // browser never fetches them and they show blank when swapped in. Make them eager
    // and warm the cache so a clicked slide always has its image ready.
    slides.forEach(function (s) {
      var img = s.querySelector('img');
      if (!img) return;
      img.setAttribute('loading', 'eager');
      var pre = new Image();
      if (img.srcset) pre.srcset = img.srcset;
      pre.src = img.currentSrc || img.src;
    });

    // ── 1. Determine initial active slide ───────────────────────────────────
    var activeIdx = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
    if (activeIdx < 0) activeIdx = 0;

    var thumbStart = 0; // first visible thumbnail index (the strip "page")
    var thumbBtns  = [];
    var prevArrow  = null;
    var nextArrow  = null;

    function maxStart() { return Math.max(0, slides.length - PER_PAGE); }

    // ── 2. Select a slide (changes the MAIN image only — never moves the strip) ──
    function showSlide(idx) {
      activeIdx = ((idx % slides.length) + slides.length) % slides.length;

      slides.forEach(function (s, i) {
        if (i === activeIdx) {
          s.classList.add('is-active');               // keep Dawn's CSS in sync
          s.style.setProperty('display', 'block', 'important');
        } else {
          s.classList.remove('is-active');
          s.style.setProperty('display', 'none', 'important');
        }
      });

      thumbBtns.forEach(function (btn, i) {
        btn.style.outline      = (i === activeIdx) ? '2px solid #264C21' : '2px solid transparent';
        btn.style.outlineOffset = '2px';
      });
    }

    // ── 3. Page the thumbnail strip (arrows) — does NOT change the main image ──
    function setThumbStart(n) {
      thumbStart = Math.max(0, Math.min(n, maxStart()));
      var btnW = thumbBtns.length ? thumbBtns[0].getBoundingClientRect().width : 0;
      track.style.transform = 'translateX(-' + (thumbStart * (btnW + 8)) + 'px)';
      updateArrows();
    }

    // Grey when there's nothing more in that direction, green when there is.
    function updateArrows() {
      if (!prevArrow || !nextArrow) return;
      var atStart = thumbStart <= 0;
      var atEnd   = thumbStart >= maxStart();
      prevArrow.querySelector('svg').setAttribute('stroke', atStart ? '#C2C7C0' : '#264C21');
      nextArrow.querySelector('svg').setAttribute('stroke', atEnd   ? '#C2C7C0' : '#264C21');
      prevArrow.style.cursor = atStart ? 'default' : 'pointer';
      nextArrow.style.cursor = atEnd   ? 'default' : 'pointer';
    }

    // ── 4. Build the thumbnail strip ────────────────────────────────────────
    // strip width == main image width; arrows sit absolutely OUTSIDE that width.
    var strip = document.createElement('div');
    strip.className = 'waw-gallery-strip';
    strip.style.cssText = 'position:relative;width:100%;margin-top:10px;';

    var viewport = document.createElement('div');
    viewport.className = 'waw-thumb-viewport';
    viewport.style.cssText = 'width:100%;overflow-x:auto;overflow-y:hidden;-webkit-overflow-scrolling:touch;scroll-behavior:smooth;';

    var track = document.createElement('div');
    track.style.cssText = 'display:flex;gap:8px;';

    slides.forEach(function (slide, i) {
      var img = slide.querySelector('img');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.style.cssText = [
        'flex:0 0 calc((100% - ' + ((PER_PAGE - 1) * 8) + 'px) / ' + PER_PAGE + ')',
        'aspect-ratio:1',
        'overflow:hidden',
        'border-radius:4px',
        'padding:0',
        'cursor:pointer',
        'background:#EFEFED',
        'outline:2px solid transparent',
        'outline-offset:2px',
        'transition:outline-color 0.15s',
        'border:none'
      ].join(';');

      if (img) {
        var t      = new Image();
        t.src      = img.src;
        t.alt      = img.alt || '';
        t.style.cssText = 'width:100%;height:100%;object-fit:cover;display:block;pointer-events:none;';
        btn.appendChild(t);
      }

      (function (index) {
        btn.addEventListener('click', function () { showSlide(index); });
      }(i));

      thumbBtns.push(btn);
      track.appendChild(btn);
    });

    viewport.appendChild(track);

    // ── 5. Arrows (only when > PER_PAGE slides) ─────────────────────────────
    // Bare chevron in brand green, no circle/background.
    function makeArrow(dir) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.setAttribute('aria-label', dir === 'prev' ? 'Previous images' : 'Next images');
      var points = dir === 'prev' ? '15 18 9 12 15 6' : '9 18 15 12 9 6';
      btn.innerHTML =
        '<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#264C21" ' +
        'stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">' +
        '<polyline points="' + points + '"/></svg>';
      btn.style.cssText = [
        'position:absolute', 'top:50%', 'transform:translateY(-50%)',
        'width:30px', 'height:30px',
        'background:transparent', 'border:none', 'padding:0', 'cursor:pointer',
        'display:flex', 'align-items:center', 'justify-content:center',
        'opacity:0.85', 'transition:opacity 0.2s', 'z-index:2',
        dir === 'prev' ? 'left:-40px' : 'right:-40px'
      ].join(';');
      btn.addEventListener('mouseenter', function () { btn.style.opacity = '1'; });
      btn.addEventListener('mouseleave', function () { btn.style.opacity = '0.85'; });
      return btn;
    }

    // Thumbnails fill the full strip (= main image) width; arrows are positioned
    // absolutely just outside the left/right edges. Arrows PAGE the strip
    // (reveal more thumbnails) — they do not change the main image.
    strip.appendChild(viewport);

    // Append INSIDE the gallery element so it stays directly under the main image
    // and scrolls together with it (no sticky overlap, no disappearing on reflow).
    gallery.appendChild(strip);

    // ── 6. Initialise ────────────────────────────────────────────────────────
    // Each thumb is 1/PER_PAGE of the strip width via CSS calc (no JS sizing/timing needed);
    // with overflow-x:auto the extra thumbs simply scroll into view.
    showSlide(activeIdx);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGallery);
  } else {
    initGallery();
  }
}());
